import api from 'src/services/api';
import * as utils from './apiUtils';
import {
  type AdminCommentTypeIndexResponse,
  toAdminCommentType,
} from 'src/models/apis/commentType/adminCommentTypeResponse';
import type { AdminCommentType } from 'src/models/commentType';
import type { CommentTypeResponse } from 'src/models/apis/master/masterResponse';
import type { CommentType } from 'src/models/master';
import type {
  AdminCommentTypeCreateParams,
  AdminCommentTypeUpdateParams,
} from 'src/models/apis/commentType/adminCommentTypeRequest';

export default {
  async adminIndex(): Promise<AdminCommentType[]> {
    const response = await api.get<AdminCommentTypeIndexResponse>(utils.getApiUrl('/admin/comment_types'));
    return response.data.map(toAdminCommentType);
  },
  async adminCreate(params: AdminCommentTypeCreateParams): Promise<CommentType> {
    const response = await api.post<CommentTypeResponse>(utils.getApiUrl('/admin/comment_types'), params);
    return toAdminCommentType(response.data);
  },
  async adminUpdate(id: number, params: AdminCommentTypeUpdateParams): Promise<CommentType> {
    const response = await api.put<CommentTypeResponse>(utils.getApiUrl(`/admin/comment_types/${id}`), params);
    return toAdminCommentType(response.data);
  },
  async adminDestroy(id: number): Promise<CommentType> {
    const response = await api.delete<CommentTypeResponse>(utils.getApiUrl(`/admin/comment_types/${id}`));
    return toAdminCommentType(response.data);
  },
};
